import { render } from "./NewRentalCoupon.vue?vue&type=template&id=bfcf2e36&scoped=true"
import script from "./NewRentalCoupon.vue?vue&type=script&lang=js"
export * from "./NewRentalCoupon.vue?vue&type=script&lang=js"

import "./NewRentalCoupon.vue?vue&type=style&index=0&id=bfcf2e36&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcf2e36"]])

export default __exports__